import {
  BellOutlined,
  CustomerServiceOutlined,
  FileTextOutlined,
  FormOutlined,
  GroupOutlined,
  MenuOutlined,
  ShopOutlined,
  SnippetsOutlined,
  StarOutlined,
  TeamOutlined,
  UserOutlined,
  AlertOutlined,
} from "@ant-design/icons";
import { AdminLayout } from "layouts/AdminLayout";
import React from "react";
import { NotFoundPage } from "views/404/NotFoundPage";
import { BannerPage } from "views/Banner/BannerPage";
import { BusinessTypePage } from "views/BusinessType/BusinessTypePage";
import { ContactPage } from "views/Contact/ContactPage";
import { ContentDefinePage } from "views/ContentDefine/ContentDefinePage";
import { HomePopupPage } from "views/HomePopup/HomePopupPage";
import { IssuePage } from "views/Issue/IssuePage";
import { IssueCategoryPage } from "views/IssueCategory/IssueCategory";
import LoginPage from "views/Login/LoginPage";
import { NewsPage } from "views/News/NewsPage";
import { NewsCategoryPage } from "views/NewsCategory/NewsCategoryPage";
import { NotificationPage } from "views/Notification/NotificationPage";
import { OrderPage } from "views/Order/OrderPage";
import { PassportPage } from "views/Passport/PassportPage";
import { PositionPage } from "views/Postion/PositionPage";
import { ProfilePage } from "views/Profile/ProfilePage";
import { ReceptionistPage } from "views/Receptionist/ReceptionistPage";
import { ReviewPage } from "views/Review/ReviewPage";
import { RolePage } from "views/Role/RolePage";
import { ShopPage } from "views/Shop/ShopPage";
import { ShopNotApproved } from "views/ShopNotApproved/ShopNotApproved";
import { StaffPage } from "views/Staff/StaffPage";
import { VotePage } from "views/VotePage/VotePage";

export interface AppRoute {
  path?: string;
  index?: boolean;
  element?: React.ReactNode;
  name?: string;
  title?: string;
  children?: AppRoute[];
  icon?: React.ReactNode;
  breadcrumb?: string;
  isAccess?: boolean;
  hidden?: boolean;
  checkIsDev?: boolean;
}

export type Route = AppRoute;

export const adminRoutes: AppRoute[] = [
  {
    title: "Doanh nghiệp",
    icon: <ShopOutlined />,
    path: "/shop",
    breadcrumb: "Doanh nghiệp",
    children: [
      {
        title: "Danh sách",
        path: "list",
        breadcrumb: "Danh sách",
        index: true,
        element: <ShopPage title="Danh sách CH" />,
      },
      {
        title: "Chưa duyệt",
        path: "not-approved",
        breadcrumb: "Chưa duyệt",
        element: <ShopNotApproved title="Doanh nghiệp chưa duyệt" />,
      },
      {
        title: "Loại hình KD",
        path: "business-type",
        breadcrumb: "Loại kinh doanh",
        element: <BusinessTypePage title="Loại kinh doanh" />,
      },
      {
        title: "Chức vụ",
        path: "position",
        breadcrumb: "Chức vụ",
        element: <PositionPage title="Chức vụ" />,
      },
    ],
  },
  {
    title: "Tin tức",
    icon: <FormOutlined />,
    path: "/news",
    breadcrumb: "Tin tức",
    children: [
      {
        title: "Danh mục",
        path: "category",
        breadcrumb: "Danh mục",
        element: <NewsCategoryPage title="Danh mục" />,
      },
      {
        title: "Bài viết",
        path: "post",
        breadcrumb: "Bài viết",
        element: <NewsPage title="Bài viết" />,
      },
    ],
  },

  {
    title: "Báo cáo sự cố",
    icon: <AlertOutlined />,
    path: "/report",
    breadcrumb: "Báo cáo sự cố",
    children: [
      {
        title: "Loại sự cố",
        path: "category",
        breadcrumb: "Loại sự cố",
        element: <IssueCategoryPage title="Loại sự cố" />,
      },
      {
        title: "Báo cáo",
        path: "list",
        breadcrumb: "Báo cáo",
        element: <IssuePage title="Báo cáo" />,
      },
    ],
  },

  {
    title: "Bình chọn",
    icon: <FormOutlined />,
    path: "/vote",
    breadcrumb: "Bình chọn",
    element: <VotePage />,
  },

  {
    title: "Banner",
    icon: <MenuOutlined />,
    path: "/banner",
    breadcrumb: "Banner",
    element: <BannerPage title="Banner" />,
  },

  {
    title: "Đánh giá",
    icon: <StarOutlined />,
    path: "/review",
    breadcrumb: "Đánh giá",
    element: <ReviewPage title="Đánh giá" />,
  },
  {
    title: "Liên hệ",
    icon: <CustomerServiceOutlined />,
    path: "/contact",
    breadcrumb: "Liên hệ",
    element: <ContactPage title="Liên hệ" />,
  },
  {
    title: "Popup",
    icon: <GroupOutlined />,
    path: "/popup",
    breadcrumb: "Popup",
    element: <HomePopupPage title="Popup" />,
  },
  {
    title: "Thông báo KH",
    path: "/notification",
    breadcrumb: "Thông báo - Khách hàng",
    index: true,
    icon: <BellOutlined />,
    element: <NotificationPage title="Thông báo - Khách hàng" />,
  },
  {
    title: "Nội dung App",
    icon: <SnippetsOutlined />,
    path: "/content-define",
    breadcrumb: "Nội dung App",
    element: <ContentDefinePage title="Nội dung App" />,
  },
  {
    title: "Quản trị viên",
    icon: <TeamOutlined />,
    element: <StaffPage title="Quản trị viên" />,
    path: "/staff",
  },
  {
    title: "Lễ tân",
    icon: <TeamOutlined />,
    element: <ReceptionistPage title="Nhân viên" />,
    path: "/receptionist",
  },
  {
    title: "Quyền",
    icon: <TeamOutlined />,
    breadcrumb: "Quyền",
    element: <RolePage title="Quyền" />,
    path: "/role",
  },
  {
    title: "Cá nhân",
    icon: <UserOutlined />,
    path: "/profile",
    element: <ProfilePage title="Cá nhân" />,
  },
];

const routes: AppRoute[] = [
  {
    path: "/",
    element: <AdminLayout />,
    children: adminRoutes,
  },
  {
    path: "/login",
    element: <LoginPage title="Đăng nhập" />,
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export { routes };
